<template>
  <table class="info info--importdata">
    <thead>
      <tr>
        <th>Navn</th>
        <th>Administrationsveje</th>
        <th />
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="item in list"
        :key="item.substanceID"
      >
        <td :style="{width: '20%'}">
          {{ item.name }}
        </td>
        <td :style="{width: '70%'}">
          <span
            v-for="status in item.statuses"
            :key="status.routeOfAdministrationID"
            class="badge"
          >
            <span class="statusText">{{ status.name }}</span>
            <span
              class="badge-background"
              :class="getBadgeBackground(status.statusCompetition)"
              title="Konkurrence"
            />
            <span
              class="badge-background"
              :class="getBadgeBackground(status.statusTraning)"
              title="Træning"
            />
          </span>
        </td>
        <td
          :style="{width: '10%'}"
          class="textRight"
        >
          <router-link
            class="underline"
            :to="{ name: 'substances.single', params: { id: item.substanceID } }"
          >
            Gå til
          </router-link>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
    name: 'ImportPreparationUpdatedList',
    props: {
        list: { type: Array, required: true },
    },
    methods: {
        getBadgeBackground(statusCode) {
            if (statusCode === 0) return '';
            if (statusCode === 100) return 'badge-background--success';
            if (statusCode < 300) return 'badge-background--alert';

            return 'badge-background--danger';
        },
    },
};
</script>

<style lang="scss" scoped>
.statusText {
    pointer-events: none;
    position: relative;
    z-index: 2;
}
.textRight {
    text-align: right;
}
</style>
